import { create } from 'zustand';

import { applyBrandingToDocument, defaultBranding, TenantBranding } from '@zercode/theme';

interface BrandingState {
  branding: TenantBranding;
  /** replace the live branding (settings save) — re-applies document-level bits too */
  setBranding: (branding: TenantBranding) => void;
}

/**
 * Live tenant branding (UI state via Zustand [STD-FE]).
 * Seeded in main.tsx BEFORE first paint from the Control Plane response;
 * updated by the branding settings screen after a successful PUT so the theme
 * refreshes WITHOUT a reload (App re-renders ConfigProvider overrides +
 * ZercodeThemeProvider from this store).
 */
export const useBrandingStore = create<BrandingState>()((set) => ({
  branding: defaultBranding,
  setBranding: (branding) => {
    applyBrandingToDocument(branding);
    set({ branding });
  }
}));
